import React, { useContext, useState, useEffect, useMemo } from "react";
import { ProductContext } from "../../context/ProductContext";

const ProductImages: React.FC = () => {
  const context = useContext(ProductContext);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState<number | null>(null);

  // Memoize mediaImages to prevent unnecessary re-renders
  const mediaImages = useMemo(() => context?.product?.mediaImages || [], [context?.product?.mediaImages]);

  // Save the first image in localStorage
  useEffect(() => {
    if (mediaImages.length > 0) {
      localStorage.setItem("firstMediaImage", mediaImages[0]);
    }
  }, [mediaImages]);

  useEffect(() => {
    if (mediaImages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % mediaImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [mediaImages]);

  // Handle touch/swipe gestures
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (!touchStartX) return;

    const touchEndX = e.changedTouches[0].clientX;
    const swipeDistance = touchStartX - touchEndX;

    if (swipeDistance > 50) {
      // Swipe left → next image
      setCurrentIndex((prevIndex) => (prevIndex + 1) % mediaImages.length);
    } else if (swipeDistance < -50) {
      // Swipe right → previous image
      setCurrentIndex((prevIndex) => (prevIndex - 1 + mediaImages.length) % mediaImages.length);
    }

    setTouchStartX(null);
  };

  return (
    <div
      className="relative w-full max-w-2xl mx-auto overflow-hidden shadow-lg"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      style={{ backgroundColor: "white" }}
    >
      {mediaImages.length > 0 ? (
        <>
          <img
            src={mediaImages[currentIndex]}
            alt={`Slide ${currentIndex + 1}`}
            className="w-full h-auto object-cover transition-all duration-500 ease-in-out"
          />
          <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {mediaImages.map((_, index) => (
              <div
                key={index}
                className={`h-2 w-2 rounded-full ${index === currentIndex ? "bg-gray-800" : "bg-gray-400"}`}
              ></div>
            ))}
          </div>
        </>
      ) : (
        <div className="text-center py-4 text-gray-500">Loading....</div>
      )}
    </div>
  );
};

export default ProductImages;
